
































import { defineComponent, SetupContext } from '@nuxtjs/composition-api'

export default defineComponent({
  name: 'InputCheckbox',
  props: {
    label: {
      type: String,
      default: '',
    },
    lang: {
      type: String,
      default: '',
    },
    disabled: {
      type: Boolean,
      default: false,
    },
    error: {
      type: [String, Boolean],
      default: '',
    },
    value: {
      type: Boolean,
      default: true,
    },
    privacyTitle: {
      type: String,
      default: '',
    },
    privacyLinkUrl: {
      type: String,
      default: '',
    },
    privacyLinkLabel: {
      type: String,
      default: '',
    },
    isNewStyle: {
      type: Boolean,
      default: false,
    },
  },
  setup(_, context: SetupContext) {
    const onCheckToggle = (event: InputEvent) => {
      const checked = (event.target as HTMLInputElement)?.checked
      context.emit('input', checked)
    }

    return {
      onCheckToggle,
    }
  },
})
